export default class Mandate {
    constructor() {
        this.isValid = true;

    }
}